import * as Bixby from '$/core';

export abstract class FinancialStatementService {
  public static generateRowStyle(style: string, withColorsInClass?: boolean): Bixby.Models.GridStyle | undefined {
    if (Bixby.Utils.isNullOrEmpty(style)) {
      return undefined;
    }
    const styles = FinancialStatementService.generateStylesByRow(style, withColorsInClass);
    return styles;
  }

  private static generateStylesByRow(rowOrColumnStyle: string, withColorsInClass?: boolean) {
    const classNames: string[] = [];
    const styles: any = {};
    rowOrColumnStyle.split('|').forEach(style => {
      const color = FinancialStatementService.parseColorFromStyle(style);
      if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_HIDE) > -1) {
        classNames.push('hide_row_column');
      }
      if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_EMPTY) > -1) {
        classNames.push('hide_cell');
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_BORDER_LEFT) > -1) {
        classNames.push(withColorsInClass ? `border_left ${color}` : 'border_left');
        if (color !== null && !withColorsInClass) {
          styles.borderLeftColor = color;
        }
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_BORDER_TOP) > -1) {
        classNames.push(withColorsInClass ? `border_top ${color}` : 'border_top');
        if (color !== null && !withColorsInClass) {
          styles.borderTopColor = color;
        }
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_BORDER_RIGHT) > -1) {
        classNames.push(withColorsInClass ? `border_right ${color}` : 'border_right');
        if (color !== null && !withColorsInClass) {
          styles.borderRightColor = color;
        }
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_BORDER_BOTTOM) > -1) {
        classNames.push(withColorsInClass ? `border_bottom ${color}` : 'border_bottom');
        if (color !== null && !withColorsInClass) {
          styles.borderBottomColor = color;
        }
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_BOLD) > -1) {
        return classNames.push('font_bold');
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_UNDERLINE) > -1) {
        return classNames.push('font_underline');
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_ITALICS) > -1) {
        return classNames.push('font_italics');
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_FONT_COLOR) > -1) {
        classNames.push(withColorsInClass ? `font_color ${color}` : 'font_color');
        if (color !== null && !withColorsInClass) {
          styles.color = color;
        }
      } else if (style.indexOf(Bixby.Constants.SPREADSHEET_STYLE_FILL_COLOR) > -1) {
        classNames.push(withColorsInClass ? `fill_color ${color}` : 'fill_color');
        if (color !== null && !withColorsInClass) {
          styles.background = color;
        }
      }
    });
    return { className: classNames.join(' '), styles };
  }

  private static parseColorFromStyle(style: string) {
    const matched = style.match(/(\([-a-zA-Z0-9#]{2,256}\))/);
    if (!matched) {
      return null;
    }
    let color: string = Bixby.Utils.first(matched);
    color = color.replace('(', '');
    color = color.replace(')', '');
    return color;
  }
}
